// extracted by mini-css-extract-plugin
export default {"wrapper":"wDFIzvf12JWQAYWGQJ7u","title":"dMJ7cYwgfzaiDbQV2lvc","icon":"rqYt7mSYxIaM_G5ujdn2","period":"zxpqYzhZJg0LlXiJ5nvf","label":"bffpf8hDuaAwKsFOduPT"};